import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useServiceTypes } from "@/api/get-service-types";
import { useCreateService } from "../api/update-service";
import { ServiceForm } from "./service-form";
import { schema } from "./service-schema";

export const ServiceCreate = () => {
    const { data: serviceTypes = [] } = useServiceTypes();

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            serviceTypes: [],
            appointmentTypeID: "",
            appointmentPrice: "",
            appointmentLength: "",
            turnaroundLength: "",
        },
    });

    // Submit
    const mutation = useCreateService();

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    return (
        <ServiceForm
            methods={methods}
            onSubmit={onSubmit}
            service={[]}
            serviceTypes={serviceTypes}
            isPending={mutation.isPending}
        />
    );
};
